<template>
  <div class="checkbox">
    <sui-checkbox />
  </div>
</template>
<script>
export default {
  name: "Checkbox2",
};
</script>
<style lang="scss">
@import "@/assets/stylesheets/application";
@import "@/assets/stylesheets/register";
.ui.checkbox input:checked ~ label:after {
  color: $blue-primary !important;
}
</style>
